import { Component, Input, ViewEncapsulation } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'otis-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
 // encapsulation: ViewEncapsulation.ShadowDom
})
export class SpinnerComponent {
  constructor(public loader: LoaderService) { }
}
